<template>
  <div class="w-full">
    <div class="pl-4 flex flex-row items">
      <div v-if="hasKiosk && isSubSubCategory">
      <a @click="goBack()">
          <IconBackArrow
          class="fill-current inline-block h-6 w-6 mr-2"
          />
        </a>
      </div>
    </div>
    <div
      :class="[!isUpselling ? 'ani-min-height' : '', !hasKiosk && 'relative']"
    >
    <h1
      v-if="menu.desktop_kiosk_left_bar && hideCategoryTitle == false"  
      class="text-5xl text-center mb-4 uppercase" 
      :style="makeStyles(kioskMainText)">
        {{ selectedMenuCategory[`name_${language}`] }}
    </h1>
      <!-- Show the search bar when horizontal category and left category carousel navigation bar is not selected -->
          <div 
          v-if="isSearchEnable != 'false'"
          v-show="(menu.desktop_kiosk_left_bar || menu.is_kiosk_horiz_categ) && !isUpselling"
          class="hidden md:flex md:flex-col md:items-end justify-end sticky top-0 z-10 bg-white"
          :style="makeStyles(mainSubCategorysBackground)"
          >
          <div class="flex w-full justify-end">
            <button 
            v-if="searchInputData || isSearchKiosk"
            class="text-new-primary mr-2 px-6 rounded-xxl flex justify-center items-center mb-10"
            :style="makeStyles(backgroundImage ? '' : mainSubCategorysBackground, kioskItemBorder,isSearchKiosk ?kioskSearchBorderColor : '' )"  @click="handleSearchCloseButton">
            <svg class="pr-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
            Back
          </button>
           <div :class="['flex justify-between items-center rounded-xxl border-3 px-4 py-2 bg-transparent',
            !hasKiosk ? 'mr-4 mb-2' : 'mb-10',
            isSearchKiosk ? 'w-full' : '',
            !hasKiosk && menu.is_kiosk_horiz_categ ? 'mt-4' : '',
            ]"
            :style="makeStyles(kioskItemBorder,isSearchKiosk ?kioskSearchBorderColor : '',isSearchKiosk ?kioskSearchTextColor:'')">
                <input 
                    :placeholder="lang['search'][language]"
                    v-model="searchInputData"
                    :class="`searchInput w-full text-xl bg-transparent ${kioskSearchTextColor ? 'custom-placeholder':''}`"
                    @click="handleSearchKiosk"
                    @focus="show"
                    :style="makeStyles(backgroundImage ? '' : mainSubCategorysBackground)"
                    />

                <button v-show="!searchInputData && !isSearchKiosk">
                  <svg xmlns="http://www.w3.org/2000/svg" ref="searchIcon" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" stroke-width="2" stroke-linecap="square" stroke-linejoin="arcs"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>              
                </button>
                <button v-show="searchInputData || isSearchKiosk" @click="handleSearchCloseButton">
                  <svg xmlns="http://www.w3.org/2000/svg" ref="closeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" stroke-width="2" stroke-linecap="square" stroke-linejoin="arcs"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button> 
           </div>
           </div>
           <div 
           v-if="isSearchKiosk"
           class="w-full"
           :style="
            hasKiosk &&
            menu.kiosk_checkout_height &&
            `margin-top:calc(${menu.kiosk_checkout_height}/2)`
          ">
             <vue-touch-keyboard
              v-if="visible"
              :cancel="hide"
              :accept="accept"
              :input="input"
              :options="{
                useKbEvents: false,
                preventClickEvent: false,
              }"
              :layout="layout"
            />
           </div>
          </div>
      <div v-if="!hasKiosk">
        <alert-card
          v-if="
            selectedMenuCategory.ordering_start_time != '00:00:00' &&
            selectedMenuCategory.ordering_end_time != '00:00:00' &&
            selectedMenuCategory.is_ordering_disabled
          "
          :myTitle="getLangOrderDisabled()"
          :myDescription="getLangOrderTimes()"
          class="mx-4"
        />
      </div>

      <transition name="fade" v-if="$store.state.loadingItems">
        <MenuItemsListSkeleton />
      </transition>
      <template v-else>
        <template v-if="hasKiosk">
          <!-- For Frydate it was required to not scroll the sidebar but only the content so the classes are applied - only fridate condition -->
          <div
          v-if="!isUpselling"
          :class="[!menu.desktop_kiosk_left_bar && !menu.is_kiosk_horiz_categ ? 'mt-6' : '']"
          >
          <div
          v-if="menu.layout == 'frydate' && !isSearchKiosk"
          class="text-6xl uppercase sticky top-0 z-10"
          :style="makeStyles(backgroundImage ? '' : mainSubCategorysBackground, titleFont)">
            {{ selectedMenuCategory[`name_${language}`] }}
          </div>
          <div
          :class="[
            'w-full grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-8',
            isIOSChrome && 'pb-94',              
            hasKiosk && menu.layout =='frydate' ? 'md:pb-0 font-sans' : 'md:pb-64'
          ]"
          >
            <MenuItemKiosk
              ref="menuItemKiosk"
              v-for="(item, index) in filteredMenuItems"
              :item="item"
              :key="index"
              useGrid
              @removeItem="
                ({ correctItems }) => {
                  deleteCorrectitem = correctItems;
                }
              "
            />
          </div>
          </div>
          <template v-else>
            <div v-for="i in upsaleGroups" :key="i.Id"
            v-if="isUpselling">
            <div class="flex items-center">
              <div
                class="text-2xl text-gray-600 font-bold w-full text-center"
                v-if="i[`name_${language}`]"
                :style="upsellingTitleColor"
              >
                {{ i[`name_${language}`] }}
              </div>
              <p v-if="i.maxSelectedAmount > 0" class="text-xs whitespace-no-wrap pr-6">
                {{ lang["maximum_addition_selection"][language] }}:
                {{ i.maxSelectedAmount }}
              </p>
            </div>
              <div class="grid grid-cols-3 gap-8 p-8">
                <div
                  v-for="item in i.groupMenuItems"
                  :key="item['Id']"
                  class="col-span-1"
                >
                <!-- @click="handleUpsell(i, item, callback)" -->
                <MenuItemKiosk
                :item="item"
                :upsellGroup="i"
                isUpselling
                @handleUpsell="(i, item) => handleUpsell(i, item)"
                    useGrid
                    :isSelectedUpselling="isItemSelected(item)"
                    :style="makeStyles(
              (selectedUpsells.includes(item.Id)
                ? listsActiveBackground
                : ''))
            "
                    />
                </div>
              </div>
            </div>
          </template>
        </template>
        <div
          v-else
          :class="[
            'w-full md:flex md:flex-wrap md:overflow-auto md:pb-0',
            isIOSChrome && 'pb-94',
            hasKiosk && 'md:pb-40',
          ]"
        >
          <!-- Upselling custom group name-->
          <div
            v-if="
              isUpselling &&
              upsellingProp &&
              upsellingProp.upselling_custom_group_name
            "
            class="mt-4 w-full"
          >
            <p
              :style="goBackButtonText"
              class="mx-4 text-2xl text-center font-bold"
            >
              {{ upsellingProp.upselling_custom_group_name }}
            </p>
          </div>

          <!-- this is used to show each category of items in infinite scroll feature
                in isUpselling case we need to execute loop once. -->
          <div
            v-for="groupItem in isUpselling
              ? [[]]
              : infiniteScroll && searchInputData ? [[]] : $store.getters.groupedMenuItems"
            :id="`menu-group-item-${groupItem.Id}`"
            :key="groupItem.Id"
            class="w-full"
          >
            <h1 v-if="groupItem.Id" class="text-xl py-2 px-4 mt-4 font-bold">
              {{ getMenuCategoryName(groupItem.Id) }}
            </h1>
            <div
              :class="[
                'w-full md:flex md:flex-wrap md:overflow-auto md:pb-0',
                isIOSChrome && 'pb-94',
                hasKiosk && 'md:pb-40',
              ]"
            >
              <div
                :class="[
                  'w-full mt-4 rounded-large bg-p md:w-1/2 md:mt-8 xl:w-1/3 2xl:w-1/4',
                  hasKiosk ? 'md:w-1/3 mt-12' : 'md:w-1/2 xl:w-1/3',
                ]"
                v-for="item in isUpselling
                  ? upsellingProp.data
                  : infiniteScroll
                  ? filterItems(groupItem.items)
                  : filteredMenuItems"
                :key="item.Id"
                @click="
                  item.hasSubItems == true
                    ? $router.push(
                        '/' +
                          $route.params.menuHash +
                          '/sub/category/' +
                          $route.params.categoryId +
                          '/menuItemId/' +
                          item.Id
                      )
                    : '#'
                "
              >
                <MenuItem
                  ref="menuItem"
                  :item="item"
                  :groupItem="groupItem"
                  :showModifierModal="showModifierModal"
                  :removeFromCart="removeFromCart"

                />
              </div>
            </div>
          </div>
          <ItemModifiers
            v-if="!hasKiosk && !currentItem.isComboDeal"
            :modifiers="modifiers"
            :currentItem="currentItem"
            :checkModifiers="checkModifiers"
            @open-modifier="openingModifier"
            :itemDescription="itemDescription"
            :selectedModifiers="selectedModifiers"
            @before-close="beforeCloseItemModifier"
            :disableAddToCartButton="disableAddToCartButton"
            :addToCartWithModifiers="addToCartWithModifiers"
            :enableNextStep="enableNextStep"
            :canGoBack="canGoBack"
          />
        </div>
      </template>
      <div v-if="!hasKiosk" class="hidden">
        <SwipeCartFromBottom />
      </div>

      <modal
        name="deleteItem"
        width="90%"
        height="auto"
        class="py-10"
        scrollable
        @before-close="closingDeleteItemModal"
      >
        <div class="mb-2 mt-4 mx-4 flex justify-between">
          <p>Welk item wil je verwijderen?</p>
          <a @click.prevent="$modal.hide('deleteItem')">
            <IconCancel
              :fill="btnDestructiveIcon"
              :stroke="btnDestructiveIcon"
            />
          </a>
        </div>

        <div class="w-full mb-10 px-4" cellspacing="0">
          <transition-group name="fade" tag="div">
            <div
              v-for="{ cartItem, amount } in hasKiosk
                ? deleteCorrectitem[0]
                : showItemsToDelete"
              :key="cartItem.Id"
              :class="[
                'flex items-center mb-2 p-2 pb-4 h-full transition duration-500 border-b-2',
                backgroundColor ? theme.middleScreen.backgroundColor : '',
              ]"
            >
              <div class="w-4/5 flex">
                <div v-show="!backgroundColor" class="justify-center flex mr-4">
                  <div class="w-12 h-12 overflow-hidden">
                    <Picture
                      v-if="cartItem.pictureUrl"
                      :src="cartItem.pictureUrl"
                      class="rounded-lg rouned-lg object-cover overflow-hidden"
                      alt
                    />
                  </div>
                </div>
                <!-- left div -->
                <div class="text-left md:table-cell h-full w-3/4 pr-1">
                  <p
                    :class="['text-sm lg:text-base font-medium']"
                    :style="processTekst"
                  >
                    <small class="text-primary-light"></small>
                    {{ cartItem[`name_${language}`] }}
                  </p>
                  <div>
                    <small
                      :class="['text-xxs']"
                      v-for="(
                        additionGroup, index
                      ) in cartItem.OrderItemAdditions"
                      :key="index"
                      :style="processTekst"
                    >
                      {{ additionGroup["Addition"][`name_${language}`] }}
                      <!-- extra prices -->
                      <span
                        v-if="additionGroup['Addition']['price'] != 0"
                        v-currency="additionGroup['Addition']['price']"
                      >
                      </span>

                      <label
                        v-if="index + 1 < cartItem.OrderItemAdditions.length"
                        >,</label
                      >
                    </small>
                  </div>
                </div>
              </div>
              <div
                :class="['w-1/7 justify-begin flex ml-2']"
                :style="processTekst"
              >
                x{{ hasKiosk ? $_.countBy(cartItems, cartItem).true : amount }}
              </div>
              <div class="text-right md:table-cell w-1/4">
                <span
                  :class="[
                    'text-sm lg:text-base font-bold',
                    /* theme.body.textColor */ 'text-new-primary',
                  ]"
                  :style="text"
                  v-currency="totalCartPrice(cartItem)"
                >
                </span>
              </div>
              <div class="flex w-1/6 justify-end mr-1">
                <div>
                  <div>
                    <a @click.prevent="removeItem(cartItem)">
                      <IconCancel
                        :fill="btnDestructiveIcon"
                        :stroke="btnDestructiveIcon"
                        classes="fill-current inline-block h-6 w-6 p-2 rounded-full cursor-pointer bg-background-red"
                      />
                    </a>
                  </div>
                </div>
                <!-- Has Not Kiosk -->
                <div></div>
                <div></div>
                <div></div>
                <!-- End Has Not Kiosk -->
              </div>
            </div>
          </transition-group>
        </div>
      </modal>
        <!-- :numberOfOrder="numberOfOrder" -->
      <ItemModifiersKiosk
        v-if="isMobileDevice ? !currentItem.isComboDeal && hasKiosk : hasKiosk"
        :currentItem="currentItem"
        :selectedModifiers="selectedModifiers"
        :disableAddToCartButton="disableAddToCartButton"
        :enableNextStep="enableNextStep"
        :modifiers="modifiers"
        :canGoBack="canGoBack"
        :addToCartWithModifiers="addToCartWithModifiers"
        :checkModifiers="checkModifiers"
        :itemDescription="itemDescription"
        @open-modifier="openingModifier"
        @before-close="closingModal"
        :closingModal="closingModal"
        
      />
      <ItemModifiersCombo
            v-if="hasKiosk ? isMobileDevice && currentItem.isComboDeal :  currentItem.isComboDeal"
            :modifiers="modifiers"
            :enableNextStep="enableNextStep"
            :canGoBack="canGoBack"
            :currentItem="currentItem"
            :checkModifiers="checkModifiers"
            @open-modifier="openingModifier"
            :itemDescription="itemDescription"
            :selectedModifiers="selectedModifiers"
            @before-close="beforeCloseItemModifier"
            :disableAddToCartButton="disableAddToCartButton"
            :addToCartWithModifiers="addToCartWithModifiers"
          />
    </div>
    <!-- <div class="fixed bottom-0 mt-4 left-0 w-full right-0">
    <vue-touch-keyboard
      v-if="visible"
      :cancel="hide"
      :accept="accept"
      :input="input"
      :options="{
        useKbEvents: false,
        preventClickEvent: false,
      }"
      :layout="layout"
    />
    </div> -->
    <modal
          name="confirmAge"
          class="roundedmodal"
          width="90%"
          :maxWidth="750"
          height="auto"
          :adaptive="true"
          scrollable
        >
          <div class="mt-3 flex justify-end pr-3">
            <a @click.prevent="$modal.hide('confirmAge')">
              <IconCancel
                :fill="btnDestructiveIcon"
                :stroke="btnDestructiveIcon"
                :style="deleteIconKioskBackground"
              />
            </a>
          </div>
          <div class="pl-8 pr-8 pb-8">
            <div>
              <h3 class="text-center text-4xl font-bold">
                {{ menu["minimum_age_message" + "_" + language] }}
              </h3>
            </div>
            <div class="flex justify-center mt-6">
              <Button
                @click="cancelAge"
                class="bg-red-600 text-white mr-6 whitespace-no-wrap text-xl"
                :style="makeStyles(hasKiosk&&mainButtonRadius)"
              >
                {{ lang["no"][language] }}</Button
              >
              <Button
                @click="confirmAge"
                class="bg-blue-600 text-white whitespace-no-wrap text-xl"
                :style="makeStyles(hasKiosk&&mainButtonRadius)"
              >
                {{ lang["yes"][language] }}</Button
              >
            </div>
          </div>
        </modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import lang from "../lang";
import _ from "lodash";
import axios from "axios";
import { layouts } from "../utils/vendors/touch-keyboard.vue";

import MenuItemKiosk from "../components/MenuItemKiosk.vue";
import MenuItemsListSkeleton from "../components/SkeletonLoaders/MenuItemsListSkeleton.vue";
import SwipeCartFromBottom from "./SwipeCartFromBottom";
import { pricify, styles } from "../utils";
import { sortCartByAdditions } from "../utils";

import AlertCard from "../components/Alert/AlertCard.vue";
import MenuItem from "../components/MenuItem.vue";
import ItemModifiers from "../components/itemModifiers.vue";
import ItemModifiersCombo from "../components/itemModifiersCombo.vue";
import ItemModifiersKiosk from "../components/itemModifiersKiosk.vue";
import IconBackArrow from "../components/icons/iconBackArrow.vue";
import IconCancel from "../components/icons/iconCancel.vue";
import Button from "../components/Button.vue";

// const ClipLoader = require("vue-spinner/src/ClipLoader.vue").default;

export default {
    name: "Subcategory",
    components: {
      SwipeCartFromBottom,
      MenuItemsListSkeleton,
      AlertCard,
      MenuItemKiosk,
      MenuItem,
      ItemModifiers,
      ItemModifiersKiosk,
      IconBackArrow,
      IconCancel,
      ItemModifiersCombo,
      Button,
  },
  data() {
    return {
      lang: lang,
      itemBeingAdded: "",
      accumulativeAdditions: [],
      selectedModifiers: [],
      modifiersMessage: "",
      disableAddToCartButton: false,
      disableAddButton: false,
      mediumWidth: false,
      listKiosk: false,
      // numberOfOrder: 1,
      allChosenItems: [],
      deleteCorrectitem: [],
      currentItemPrice: 0,
      minModifierCount: 0,
      showItemsToDelete: [],
      showModifierModal: true,
      disableAddWithModifiers: false,
      enableNextStep: false,
      spinnerInItems: false,
      allProducts: "",
      visible: false,
      input: undefined,
      selectedUpsells: [],
    };
  },
  props: {
    modifier: {
      type: Object,
      required: false,
    },
    upsellingProp: {
      type: Object,
      required: false,
    },
    // isUpselling: {
    //   type: Boolean,
    //   required: false,
    // },
  },
  computed: {
    ...mapGetters([
      "isMobileDevice",
      "infiniteScroll",
      "menuItems",
      "theme",
      "hasKiosk",
      "currency",
      "orderingEnabled",
      "selectedMenuCategory",
      "isSubSubCategory",
      "menuCategories",
      "parentSelectedMenuCategory",
      "menu",
      "modifierNumber",
      "isIOSChrome",
      "upselling",
      "orderData",
      "itemPrice",
      "minSelectedAddition",
      "language",
      "userAgent",
      "desktopMode",
      "menuSubCategories",
      "minSelectedAdditionComboTotal",
      "minModifierComboCount",
      "comboItemSelectionStep",
      "menuHash",
      "searchItemInput",
      "isSearchKiosk",
      "isUpselling",
      "modifierSelectionStep",
      "modifiersSelectionGroups",
        "minimumAgeProduct"
]),
    ...mapGetters("Cart", [
      "cartItems",
      "items" ,
      "stickerId" ,
      "orderItemCount",
      "subCategoryCurrentItem",
      "subCategoryCurrentItemModifier",
      "subCategoryCurrentModifiers",
      "comboDealAdditions",
      "upsaleGroups",
    ]),
    ...mapGetters("Theme", [
      "isSearchEnable",
      "kioskItemBorder",
      "goBackButtonText",
      "backgroundColor",
      "text",
      "btnDestructiveIcon",
      "processTekst",
      "kioskCategoryTitle",
      "upsellingTitleColor",
      "itemDescription",
      "mainSubCategorysBackground",
      "mainSubCategorysBackground",
      "kioskKeyboardBackgroundColor",
      "kioskKeyboardKeyBackgroundColor",
      "kioskKeyboardKeyTextColor",
      "kioskKeyboardTextColor",
      "kioskKeyboardKeysRadius",
      "kioskSearchBorderColor",
      "kioskSearchTextColor",
      "backgroundImage",
      "titleFont",
      "listsActiveBackground",
      "deleteIconKioskBackground",
      "mainButtonRadius",
      "kioskMainText",
      "hideCategoryTitle"
    ]),
    searchInputData: {
      get() {
        return this.$store.getters["searchItemInput"];
      },
      set(value) {
        this.$store.commit("updateSearchItemInput",value)
      }
    },
    selectedModifiersGroupIds() {
      return this.selectedModifiers.map((el) =>
        el.AdditionGroupId && el.combo_deal_item_id ? el.AdditionGroupId : false
      );
    },
    collectedCartItems() {
      const items = this.cartItems;
      const result = sortCartByAdditions(items);
      return result;
    },
    desktopMode() {
      return this.userAgent.device.type === "desktop";
    },
    currentItem: {
      get() {
        return this.subCategoryCurrentItem;
      },
      set(value) {
        return this.$store.commit("Cart/updateSubCategoryCurrentItem", value);
      },
    },
    modifiers:{
      get(){
        return this.subCategoryCurrentItemModifier;
      },
      set(value){
        return this.$store.commit("Cart/updateSubCategoryCurrentItemModifier",value);
      }
    },
    canGoBack() {
      return (
        this.minModifierComboCount == 0 ||
        this.minModifierComboCount == this.minSelectedAdditionComboTotal
      );
    },
   filteredMenuItems() {
      if (this.searchItemInput) {
        return this.allProducts.filter((menuItem) => menuItem["name" + "_" + this.language].toLowerCase().includes(this.searchItemInput.toLowerCase()))
      }
      else if (this.isSearchKiosk) {
       return null
     }
      this.hide()
      return this.menuItems
    }, 
  },
  methods: {
    setPlaceholderColor() {
      const root = document.documentElement;
      if (!this.kioskSearchTextColor) return;
      const match = this.kioskSearchTextColor.match(/#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})/)
      if (!match) return;
      const color = this.kioskSearchTextColor.match(/#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})/)[0];
      root.style.setProperty('--search-placeholder-color', color);
    },
    setSvgStrokeColor() {
      this.$nextTick(() => {
        const searchIcon = this.$refs.searchIcon;
        const closeIcon = this.$refs.closeIcon;
        const color = getComputedStyle(document.documentElement).getPropertyValue('--search-placeholder-color').trim();
  
        if (searchIcon) {
          searchIcon.setAttribute('stroke', color);
        }
        if (closeIcon) {
          closeIcon.setAttribute('stroke', color);
        }
      })
    },
    handleUpsell(upsellGroup, item) {
      const index = this.selectedUpsells.findIndex(selectedItem => selectedItem.Id === item.Id);
      // If the item is found in the array, remove it
      if (index !== -1) {
        this.selectedUpsells.splice(index, 1);

      } else {
         // Find items in selectedUpsells that are part of the upsellGroup
        let selectedItemsInGroup = ''
        selectedItemsInGroup = this.selectedUpsells.filter(selectedItem => 
          upsellGroup.groupMenuItems.some(groupItem => groupItem.Id === selectedItem.Id)
        );
        // Check if the maxSelectedAmount is reached
        if (selectedItemsInGroup.length < upsellGroup.maxSelectedAmount && upsellGroup.maxSelectedAmount > 0) {
          // If the max is not reached, add the item to the array
          this.selectedUpsells.push(item);
        }
        else if (selectedItemsInGroup.length == 0) {
          this.selectedUpsells.push(item);
        }
      }
      this.$store.commit("Cart/updateSelectedUpsellItems", this.selectedUpsells);
    },
    isItemSelected(item) {
      return this.selectedUpsells.some(selectedItem => selectedItem.Id === item.Id);
    },
    filterItems(items) {
    if(this.searchInputData)
      return this.allProducts.filter((menuItem) => menuItem["name" + "_" + this.language].toLowerCase().includes(this.searchItemInput.toLowerCase()))
    else return items
    },
    confirmAge() {
      if (this.hasKiosk) {
        const menuItemKioskRefs = this.$refs.menuItemKiosk;
        const menuItemKioskInstance = menuItemKioskRefs.find(ref => ref.item.Id === this.minimumAgeProduct.Id);
        menuItemKioskInstance.addToCart(this.minimumAgeProduct);
        this.$modal.hide("confirmAge");
      }
      // this.$refs.menuItemKiosk.addToCart(this.minimumAgeProduct);
      else {
        const menuItemRefs = this.$refs.menuItem;
        const menuItemInstance = menuItemRefs.find(ref => ref.item.Id === this.minimumAgeProduct.Id);
        menuItemInstance.addToCart(this.minimumAgeProduct);
        this.$modal.hide("confirmAge");
      }
      this.$store.commit("updateMinimumAgeProduct", "")
    },
    cancelAge() {
      this.$modal.hide("confirmAge");
      this.$store.commit("updateAgeConfirmed", false);
      // this.$store.commit("Cart/emptyCart");
      // this.$router.push({ path: "/" + this.menuHash + "/start/kiosk" ,query:this.$route.query});
    },
    handleSearchKiosk() {
      if (this.hasKiosk) {
        this.$store.commit("updateIsSearchKiosk",true)        
      }
    },
    show(e) {
      if (this.hasKiosk) {
        this.input = e.target;
        this.layout = layouts[`kiosk_${e.target.dataset.layout}`]||layouts.kiosk;
        if (!this.visible) this.visible = true;
      }
    },
    accept() {
      this.$modal.show('cart-items');
      if (this.cartItems.length > 0) {
        this.handleSearchCloseButton();
        this.hide();
        this.$store.dispatch("UPDATE_CART_PROCESS")
      }
    },
    hide() {
      this.visible = false;
    },
    handleSearchCloseButton() {
      this.searchInputData = '';
      if(this.isSearchKiosk) {
        this.$store.commit("updateIsSearchKiosk",false)    
        this.hide();
      }
    },
    openingModifier() {
      if(this.currentItem.isComboDeal) {
        this.checkNextButtonEnable();
      }
      this.checkNextButtonEnableAdditions();
      this.checkAddToCartButtonEnable();
    },
    checkAddToCartButtonEnable() {
      let disableAddToCartButton = false;
      for (const modifier of this.modifiers) {
        let allSelected;
        allSelected = this.hasAllRequiredAdditionSelected(modifier);
        if (!allSelected) {
          disableAddToCartButton = true;
          break;
        }
      }
      return (this.disableAddToCartButton = disableAddToCartButton);
    },
    hasAllRequiredAdditionSelected(modifier) {
      let allSelected = undefined;
      if (modifier.minSelectedAmount <= 0) {
        return (allSelected = true);
      }
      /** If Selected modifiers is greater than or equal to min required selected amount */
      if (
        modifier.minSelectedAmount <=
        this.$_.countBy(this.selectedModifiers, (el) => {
          return el.AdditionGroupId == modifier.AdditionGroupId;
        })[true]
      ) {
        if (this.currentItem.isComboDeal) {
          /** if item does not have any Additions then mark as all selected */
          if (!this.comboDealAdditions.data.length) {
            allSelected = true;
          }

          /** Check for all additions are selected */
          for (const el of this.comboDealAdditions.data) {
            if (el.minSelectedAmount <= 0) {
              allSelected = true;
            } else {
              let sum = 0;
              /** Count selected Additions of a particular Modifier */
              for (const i in el.Additions) {
                let count =
                  this.$_.countBy(
                    this.selectedModifiers,
                    (addition) =>
                      addition.Id == el.Additions[i].Id &&
                      addition.combo_deal_item_id ==
                        el.Additions[i].combo_deal_item_id
                  ).true ?? 0;
                sum += count;
              }
              if (el.minSelectedAmount <= sum) {
                allSelected = true;
              } else {
                /** If any addition is not selected no need to check further */
                return allSelected = false;
                // break;
              }
            }
          }
        } else {
          if (!modifier.Additions.length) {
            allSelected = true;
          }
          let sum = 0;
          /** Count selected Additions of a particular Modifier */
          for (const i in modifier.Additions) {
            let count =
              this.$_.countBy(
                this.selectedModifiers,
                (addition) =>
                  addition.Id == modifier.Additions[i].Id &&
                  addition.AdditionGroupId ==
                    modifier.Additions[i].AdditionGroupId
              ).true ?? 0;
            sum += count;
          }
          if (modifier.minSelectedAmount <= sum) {
            allSelected = true;
          } else {
            /** If any addition is not selected no need to check further */
            return allSelected = false;
          }
        }
      } else {
       return allSelected = false;
      }
      return allSelected;
    },

    checkNextButtonEnable() {
      let allSelected = undefined;
      if (this.modifiers[this.comboItemSelectionStep].minSelectedAmount <= 0) {
        allSelected = true;
        if(this.currentItem.isComboDeal){
          this.checkAddToCartButtonEnable();
        }
        return;
      }
      /** If Selected modifiers is greater than or equal to min required selected amount */
      if (
        this.modifiers[this.comboItemSelectionStep].minSelectedAmount <=
        this.$_.countBy(this.selectedModifiers, (el) => {
          return (
            el.AdditionGroupId ==
            this.modifiers[this.comboItemSelectionStep].AdditionGroupId
          );
        })[true]
      ) {
        /** if item does not have any Additions then mark as all selected */
        if (!this.comboDealAdditions.data.length) {
          allSelected = true;
        }

        /** Check for all additions are selected */
        for (const el of this.comboDealAdditions.data) {
          if (el.minSelectedAmount <= 0) {
            allSelected = true;
          } else {
            let sum = 0;
            /** Count selected Additions of a particular Modifier */
            for (const i in el.Additions) {
              let count =
                this.$_.countBy(
                  this.selectedModifiers,
                  (addition) =>
                    addition.Id == el.Additions[i].Id &&
                    addition.combo_deal_item_id ==
                      el.Additions[i].combo_deal_item_id
                ).true ?? 0;
              sum += count;
            }
            if (el.minSelectedAmount <= sum) {
              allSelected = true;
            } else {
              /** If any addition is not selected no need to check further */
              allSelected = false;
              break;
            }
          }
        }
      } else {
        allSelected = false;
      }
      this.enableNextStep = allSelected;
      // For combo Deal if all modifiers are selected then check for add to cart button enable
      if (allSelected&&this.currentItem.isComboDeal) {
        this.checkAddToCartButtonEnable();
      } 
    },
    checkNextButtonEnableAdditions() {
      let allSelected = undefined;
      /** If Selected modifiers is greater than or equal to min required selected amount */
      let filteredModifiers = this.modifiers.filter(modifier => modifier.additionStep === this.modifierSelectionStep)
      for (const modifier of filteredModifiers) {
        // .forEach(modifier => {
        if (modifier.minSelectedAmount <= 0) {
          // this.disableAddToCartButton = false
          allSelected = true
      continue;
    }
           // Perform your function here
           if (
            //  this.modifiers[this.modifierSelectionStep].minSelectedAmount <=
             modifier.minSelectedAmount <=
             this.$_.countBy(this.selectedModifiers, (el) => {
               return (
                 el.AdditionGroupId ==
                //  this.modifiers[this.modifierSelectionStep].AdditionGroupId
                 modifier.AdditionGroupId
               );
             })[true]
           ) {
             allSelected = true
     
           } else {
             allSelected = false;
            //  if (!modifier.minSelectedAmount <= 0) {
               this.disableAddToCartButton = true
            //  }
             break;
           }
         }
      this.enableNextStep = allSelected;
      // For combo Deal if all modifiers are selected then check for add to cart button enable
      if (allSelected && !this.currentItem.isComboDeal) {
        this.checkAddToCartButtonEnable();
      } 
    },
    // checkNextButtonEnable() {
    //   let allSelected = undefined;
    //   if (this.modifiers[this.comboItemSelectionStep].minSelectedAmount <= 0) {
    //     allSelected = true;
    //     return;
    //   }
    //   /** If Selected modifiers is greater than or equal to min required selected amount */
    //   if (
    //     this.modifiers[this.comboItemSelectionStep].minSelectedAmount <=
    //     this.$_.countBy(this.selectedModifiers, (el) => {
    //       return (
    //         el.AdditionGroupId ==
    //         this.modifiers[this.comboItemSelectionStep].AdditionGroupId
    //       );
    //     })[true]
    //   ) {
    //     /** if item does not have any Additions then mark as all selected */
    //     if (!this.comboDealAdditions.data.length) {
    //       allSelected = true;
    //     }

    //     /** Check for all additions are selected */
    //     for (const el of this.comboDealAdditions.data) {
    //       if (el.minSelectedAmount <= 0) {
    //         console.log(
    //           "No min selected amount is required",
    //           el,
    //           el.minSelectedAmount
    //         );
    //         allSelected = true;
    //       } else {
    //         let sum = 0;
    //         /** Count selected Additions of a particular Modifier */
    //         for (const i in el.Additions) {
    //           let count =
    //             this.$_.countBy(
    //               this.selectedModifiers,
    //               (addition) =>
    //                 addition.Id == el.Additions[i].Id &&
    //                 addition.combo_deal_item_id ==
    //                   el.Additions[i].combo_deal_item_id
    //             ).true ?? 0;
    //           sum += count;
    //         }
    //         if (el.minSelectedAmount <= sum) {
    //           allSelected = true;
    //         } else {
    //           /** If any addition is not selected no need to check further */
    //           allSelected = false;
    //           break;
    //         }
    //       }
    //     }
    //   } else {
    //     allSelected = false;
    //   }
    //   this.enableNextStep = allSelected;
    // },
    /**
     * @param categoryId
     * @return String CategoryName
     * Return category name from menuCategories list if not exist return ""(empty string).
     */
    getMenuCategoryName(categoryId) {
      let menuCat = this.menuCategories.find((el) => el.Id == categoryId);
      if (Object.keys(menuCat).length) {
        return menuCat.name_en;
      }
      return "";
    },
    showModifiersWhenOrderingDisabled(item) {
      this.currentItem = item;
      this.$store
        .dispatch("Cart/GET_MENU_ITEM_ORDERING", this.currentItem.Id)
        .then((response) => {
          this.itemBeingAdded = "";
          this.minModifierCount = 0;
          // show modifier modal
          if (response.data.Modifiers.length) {
            this.modifiers = response.data.Modifiers;
            if (this.showModifierModal) {
              this.$modal.show("item-modifiers");
            }
          }
        });
    },
    closingDeleteItemModal() {
      this.showModifierModal = true;
    },

    /** delete selected modifiers */
    beforeCloseItemModifier() {
      this.$store.commit("resetModifierSelectionStep");
      this.$store.commit("updateModifiersSelectionGroups", 0);
      this.$store.commit("saveAdditionStepsArray", []);
      this.$store.commit("updateComboItemSelectionStep",0)
      this.selectedModifiers = [];
      this.accumulativeAdditions = [];
    },

    checkModifiers() {
      // In this array we will put the additionsgroups that is required but the user forgot to select
      let arr = [];
      const additions = document.querySelectorAll(`.allAdditions`);
      additions.forEach((x) => {
        // for each addition we check if AdditionSelected is added in the classlist. If they have that class we know that the user selected the required additions
        if (!x.classList.contains("AdditionSelected")) {
          // we add the required class to show the red bold text on the kiosk
          x.classList.add("required");
          // we add the animated class to use the animated zoom effect
          x.classList.add("animated");
          // we remove the effect every time so when the user click again the effect will run again
          setTimeout(function () {
            x.classList.remove("animated");
          }, 1600);
          arr.push(x);
        } else {
          // we remove the required classname when we already selected an addition
          x.classList.remove("required");
        }
      });
      // we select the first one inside the array to scroll to
      arr[0]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      // In this array we will put the additionsgroups that is required but the user forgot to select
      let array = [];
      const comboAdditions = document.querySelectorAll(`.allComboAdditions`);
      comboAdditions.forEach((x) => {
        // for each addition we check if AdditionSelected is added in the classlist. If they have that class we know that the user selected the required additions
        if (!x.classList.contains("AdditionSelected")) {
          // we add the required class to show the red bold text on the kiosk
          x.classList.add("required");
          // we add the animated class to use the animated zoom effect
          x.classList.add("animated");
          // we remove the effect every time so when the user click again the effect will run again
          setTimeout(function () {
            x.classList.remove("animated");
          }, 1600);
          array.push(x);
        } else {
          // we remove the required classname when we already selected an addition
          x.classList.remove("required");
        }
      });
      // we select the first one inside the array to scroll to
      array[0]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    },
    hideAdditionsModal() {
      this.$modal.hide("item-modifiers");
      this.disableAddToCartButton = false;
      this.disableAddButton = false;
    },
    // show the arrow of the kiosk navigation when a modal closes
    closingModal() {
      this.$store.commit("resetModifierSelectionStep");
      this.$store.commit("updateModifiersSelectionGroups", 0);
      this.$store.commit("saveAdditionStepsArray", []);
      this.$store.commit("updateMinModifierComboCount", 0);
      this.$store.commit("Cart/updateComboDealAdditions", []);
      this.accumulativeAdditions = [];
      this.selectedModifiers = [];
      this.$store.commit("updateComboItemSelectionStep", 0);
      this.enableNextStep = false;
      this.$store.commit("updateMinSelectedAddition", 0);
      this.$store.commit("updateMinSelectedAdditionTotal", 0);
      if (document.getElementsByClassName("prev")[0]) {
        document.getElementsByClassName("prev")[0].style.display = "flex";
        document.getElementsByClassName("next")[0].style.display = "flex";
        this.disableAddToCartButton = false;
      }
    },
    // delete the arrow of the kiosk navigation when a modal closes
    openingModal() {
      this.openingModifier();
      if (document.getElementsByClassName("prev")[0]) {
        document.getElementsByClassName("prev")[0].style.display = "none";
        document.getElementsByClassName("next")[0].style.display = "none";
      }
    },
    // addNumberOfOrders() {
    //   this.$store.commit("Cart/updateOrderItemCount", this.numberOfOrder++);
    // },
    // deleteNumberOfOrders() {
    //   if (this.numberOfOrder > 1) {
    //     this.$store.commit("Cart/updateOrderItemCount", this.numberOfOrder--);
    //   }
    // },
    goBack() {
      this.$store.commit(
        "updateSelectedMenuCategory",
        this.parentSelectedMenuCategory
      );
      this.$router.back();
    },
    addToCartWithModifiers() {
      this.spinnerInItems = true;
      this.disableAddToCartButton = false;
      this.disableAddButton = false;
      // this.$store.commit("Cart/updateOrderItemCount", this.numberOfOrder);
      /** Deep cloning current item to avoid hoisting. */
      if (this.disableAddToCartButton != true) {
        this.disableAddToCartButton = true;
        this.disableAddButton = true;
        let tempCurrentItem = this.$_.cloneDeep(this.currentItem);
        if (this.selectedModifiers.length >= 1) {
          tempCurrentItem["OrderItemAdditions"] = [];
          for (let i = 0; i < this.selectedModifiers.length; i++) {
            tempCurrentItem["OrderItemAdditions"].push({
              Addition: this.selectedModifiers[i],
            });
          }
        }
        // add item and update order

        this.$store
          .dispatch("Cart/UPDATE_ORDER", {
            operation: "add",
            item: tempCurrentItem,
          })
          .then(() => {
            this.disableAddButton = false;
            this.spinnerInItems = false;
            setTimeout(() => (this.disableAddToCartButton = false), 150);
          });

        this.selectedModifiers = [];
        this.accumulativeAdditions = [];
        this.$modal.hide("item-modifiers");
        this.numberOfOrder = 1;

        if (!this.hasKiosk) {
          let cartbutton = document.querySelectorAll(".fixedDesktopCart")[0];
          if (cartbutton) {
            cartbutton.classList.add("animatedViewOrderButton");
            setTimeout(function () {
              document
                .querySelectorAll(".fixedDesktopCart")[0]
                .classList.remove("animatedViewOrderButton");
            }, 1100);
          }
        }
      }
    },
    removeFromCart(item) {
      this.$modal.hide("item-modifiers");
      this.deleteCorrectitem = [];
      this.allChosenItems = [];
      for (let i = 0; i < this.cartItems.length; i++) {
        if (item.Id == this.cartItems[i].Id) {
          this.allChosenItems.push(this.cartItems[i]);
        }
      }
      this.deleteCorrectitem.push(_.uniqWith(this.allChosenItems, _.isEqual));
      if (this.deleteCorrectitem[0].length != 1) {
        if (!this.hasKiosk) {
          this.showItemsToDelete = [];
          this.collectedCartItems.map((x) => {
            if (item.Id == x.cartItem.Id) {
              this.showItemsToDelete.push(x);
            }
          });
          this.showModifierModal = false;
        }
        this.$modal.show("deleteItem");
      } else {
        if (this.disableAddButton != true) {
          this.disableAddButton = true;
          item = this.$_.find(this.items, (el) => el.Id == item.Id);
          this.currentItem = item;
          this.itemBeingAdded = this.currentItem.Id;
          /**
           * Sanitising the item before sending to the store for the removal. (Related to Upsale)
           * Upsaling adds few other key-values to the items. (Removing that.)
           */
          this.$store
            .dispatch("Cart/UPDATE_ORDER", {
              operation: "remove",
              item: this.$_.omit(item, [
                "upsell_item_available",
                "upselling_custom_group_name",
              ]),
            })
            .then(() => {
              this.itemBeingAdded = "";
              setTimeout(() => (this.disableAddButton = false), 150);
            })
            .catch(() => {
              this.itemBeingAdded = "";
            });
        }
      }
    },
    removeItem(item) {
      this.$store
        .dispatch("Cart/UPDATE_ORDER", { operation: "remove", item: item })
        .then(() => {})
        .catch(() => {});
      this.$store.commit("updateIsSwipeOpen", false);
      let index = _.findLastIndex(this.allChosenItems, item);
      if (index >= 0) {
        this.allChosenItems.splice(index, 1);
      }
      this.deleteCorrectitem = [];
      this.deleteCorrectitem.push(_.uniqWith(this.allChosenItems, _.isEqual));
      if (!this.hasKiosk) {
        this.showItemsToDelete = [];
        this.collectedCartItems.map((x) => {
          if (item.Id == x.cartItem.Id) {
            this.showItemsToDelete.push(x);
          }
        });
      }
      if (this.deleteCorrectitem[0].length == 0) {
        this.showModifierModal = true;
        this.$modal.hide("deleteItem");
      }
    },
    async removeItemsFromCart(item) {
      this.$store.commit("Cart/removeItems", item);
      this.$store.dispatch("Cart/UPDATE_ORDER", {
        operation: "remove",
        item: [],
      });
    },
    handleResize() {},
    pricify(params) {
      return pricify(params)
    },
    styles(params) {
      return styles(params);
    },
    // Calculate the total cost of Item including additional items cost
    totalCartPrice(cartItem) {
      return cartItem?.OrderItemAdditions?.reduce(
        (acc, cur) => acc + cur?.Addition?.price,
        Number(cartItem.price)
      );
    },
    getLangOrderDisabled() {
      // get translation for "orders are diss"
      return lang["order_disabled"][this.language];
    },
    getLangOrderTimes() {
      // Returns Order Times in a formatted way --> item available from hh:mm and hh:mm --
      let orderTimesStr = "";
      orderTimesStr += this.selectedMenuCategory["name" + "_" + this.language];
      orderTimesStr += lang["available_betweens"][this.language] + " ";
      orderTimesStr += this.selectedMenuCategory.ordering_start_time
        ? this.selectedMenuCategory.ordering_start_time.slice(0, -3) + " "
        : "";
      orderTimesStr += lang["and_keyword"][this.language] + " ";
      orderTimesStr += this.selectedMenuCategory.ordering_end_time
        ? this.selectedMenuCategory.ordering_end_time.slice(0, -3) + " "
        : "";

      return orderTimesStr;
    },
    // Checking if the 'add to cart' button should be visible and clickable, is_ordering_disabled = false/true
    // This check is different than 'selectedMenuCategory' because with infinity scroll the last category items can be displayed without being 'selected'
    isOrderingDisabled(groupItem) {
      // Loop through base menu info to find additional information about menu, in this case look for 'is_ordering_disabled'
      /** groupItem value is only used in infinite scroll menu , if menu is non infinity scroll type return true so that
       * this condition make no effect with and(&) operator */
      return !this.menuCategories.find((x) => x.Id == groupItem.Id)
        ?.is_ordering_disabled;
    },
  },
  created() {
    if (window.innerWidth > 769) {
      this.mediumWidth = true;
    }
    if (!this.isUpselling) {
      window.$eventBus.$on("additions-selected", (selectedAddtions) => {
      /**
       * accumulativeAdditions is temporary variable kept just to finalise the final
       * array of additions which going to be posted.
       */
      if (this.modifierNumber == 1) {
        // deselect the addition if we click on the already selected addition 
        const keyToFind = `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`;
        const findIndex = ((obj, keyToFind) => Object.keys(obj).indexOf(keyToFind))(this.accumulativeAdditions, keyToFind);
        if (findIndex < 0) {
          this.accumulativeAdditions[
          `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
        ] = [selectedAddtions.selectedModifiers];
        } else {
          if(selectedAddtions.selectedModifiers.Id != this.accumulativeAdditions[
            `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`][0].Id) {
            if (selectedAddtions.comboDealId == 0) {
                  this.accumulativeAdditions[
              `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
              ] = [selectedAddtions.selectedModifiers];
            }
            else {
              const keyToRemove = `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`;
              delete this.accumulativeAdditions[keyToRemove];
              this.accumulativeAdditions[
              `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
              ] = [selectedAddtions.selectedModifiers];
            }
          }
          else {
            const keyToRemove = `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`;
            delete this.accumulativeAdditions[keyToRemove];
            }
         }
      } else {
        if (this.comboDealAdditions.combogroupid) {
          /** get comboDealAdditions details for selected Additions */
          let groupDetail = this.comboDealAdditions.data.find(
            (el) => el.AdditionGroupId == selectedAddtions.modifierGroupId
          );
        /** if selectedAdditions is comboDealAdditions */
        if (selectedAddtions.comboDealId) {
          /** if Selected deal addition is max one time selectable or is this group not exist */
          if (
            (groupDetail && groupDetail.maxSelectedAmount == 1) ||
            !this.accumulativeAdditions[
              `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
            ]
          ) {
            const keyToFind = `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`;
            const findIndex = ((obj, keyToFind) => Object.keys(obj).indexOf(keyToFind))(this.accumulativeAdditions, keyToFind);
            if (findIndex < 0) {
            this.accumulativeAdditions[
            `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
          ] = [selectedAddtions.selectedModifiers];
          } else {
            if(selectedAddtions.selectedModifiers.Id != this.accumulativeAdditions[
                `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`][0].Id) {
                const keyToRemove = `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`;
                delete this.accumulativeAdditions[keyToRemove];
                this.accumulativeAdditions[
                `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
                ] = [selectedAddtions.selectedModifiers];
            }
            else {
              const keyToRemove = `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`;
              delete this.accumulativeAdditions[keyToRemove];
              }
          }
              // this.accumulativeAdditions[
              //   `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
              // ] = [selectedAddtions.selectedModifiers];

            } else if (
              /** if Selected deal addition is not max acceptable length push in that group */
              this.accumulativeAdditions[
                `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
              ].length < groupDetail.maxSelectedAmount ||
              groupDetail.maxSelectedAmount == -1 ||
              this.accumulativeAdditions[
                `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
              ]
                .map((el) => el.Id)
                .includes(selectedAddtions.selectedModifiers.Id)
            ) {
              let findIndex = this.accumulativeAdditions[
                `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
              ]
                .map((el) => el.Id)
                .findIndex(
                  (en) => en == selectedAddtions.selectedModifiers.Id
                );


            /** if this element not exist then add this else remove this */
              if (findIndex < 0) {
                this.accumulativeAdditions[
                  `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
                ].push(selectedAddtions.selectedModifiers);
              } else {
                this.accumulativeAdditions[
                  `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
                ].splice(findIndex, 1);
              }
            }
          } else {
            this.accumulativeAdditions[
              `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
            ] = selectedAddtions.selectedModifiers;
        }
      } else {
        this.accumulativeAdditions[
          `Group_${selectedAddtions.modifierGroupId}_${selectedAddtions.comboDealId}`
        ] = selectedAddtions.selectedModifiers;
        }
      }

      /** Based on accumulativeAdditions, a final array of objects(additions) prepared
       * which will be sent to the server over an xhr request. (Post/Patch order)
       */
      this.selectedModifiers = [];
      for (
        let i = 0;
        i < Object.keys(this.accumulativeAdditions).length;
        i++
      ) {
        if (Object.values(this.accumulativeAdditions)[i].length) {
          Object.values(this.accumulativeAdditions)[i].forEach((element) => {
            /** This means it's modifiers of Combo deals*/
            if (element?.combo_deal_item_id) {
              /** push only if parent item Id is present,
               * that means filter only modifiers that parent is added.
               */
              if (
                this.selectedModifiers.some(el=>el.Id===element.combo_deal_item_id)
              ) {
                this.selectedModifiers.push(element);
              } else if (
                this.accumulativeAdditions[
                  Object.keys(this.accumulativeAdditions)[i]
                ]
              ) {
                /** Remove from accumulativeAdditions*/
                if (Object.keys(this.accumulativeAdditions).length > 1) {
                  if (
                    Object.keys(this.accumulativeAdditions)[i] !=
                    Object.keys(this.accumulativeAdditions)[0]
                  ) {
                    delete this.accumulativeAdditions[
                      Object.keys(this.accumulativeAdditions)[i]
                    ];
                  }
                }

                /** since this one item is deleted from accumulativeAdditions change pointer to
                 * new item on current position
                 * */
                i--;
              }
            } else {
              this.selectedModifiers.push(element);
            }
          });
        }
      }
      // if (this.currentItem.isComboDeal) {
      //   this.checkNextButtonEnable();
      // }
      if (this.currentItem.isComboDeal) {
        this.checkNextButtonEnable();
        this.checkAddToCartButtonEnable();

      } else {
        if (this.modifiersSelectionGroups > 1) {
          this.checkNextButtonEnableAdditions();
        }
        else {
          this.checkAddToCartButtonEnable();
        }
      }
        
        /** Calculate total price of modifiers and update */
        let totalPriceOfModifiers = this.selectedModifiers.reduce(
          (ac, modifier) => (ac += modifier.price ?? 0),
          0
        );
      /** Total item price = item base price + total price of additions and modifiers */
        this.$store.commit(
          "updateItemPrice",
          totalPriceOfModifiers + this.currentItem.price
        );
      });
  }
  },
  watch: {
    kioskSearchTextColor() {
      this.setPlaceholderColor();
      this.setSvgStrokeColor();
    },
    comboItemSelectionStep() {
      this.checkNextButtonEnable();
    },
    modifierSelectionStep() {
      this.checkNextButtonEnableAdditions();
    }
  },
  beforeDestroy() {
    if (!this.isUpselling) {
      /** Remove the event listeners */
      window.$eventBus.$off("additions-selected");
    }
  },
  mounted() {
    this.setPlaceholderColor();
    this.setSvgStrokeColor();
    this.$store.commit("updateIsCategorySubItem", false);

    new Promise((resolve, reject) => {
        axios
          .get(`GetAllMenuItems?MenuHash=${this.menuHash}`)
          .then((response) => {
          this.allProducts = response.data.MenuItems
          })
          .catch((error) => {
            reject(error);
          });
      });
  },
  updated() {
    /** It will focus the search field in kiosk mode if the page has just one input field so keyboard will come up */
    if(this.isSearchKiosk) {
    document.querySelector('.searchInput').focus()
    }
    let test = document.querySelectorAll(
      "body .vue-touch-keyboard .keyboard .control"
    );
    let keys = document.querySelectorAll(
      "body .vue-touch-keyboard .keyboard .key"
    );
    let enterKey = document.querySelectorAll(
      "body .vue-touch-keyboard .keyboard .accept"
    );

    for (let i = 0; i < enterKey.length; i++) {
      enterKey[i].style.backgroundImage = "url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik05IDE4bDYtNi02LTYiLz48L3N2Zz4=)"
    }
    
    for (let i = 0; i < keys.length; i++) {
      if (keys[i].textContent == "7") {
        keys[i].removeAttribute("style")
      }
      keys[i].style.borderRadius = this.kioskKeyboardKeysRadius;
      keys[i].style.backgroundColor = this.kioskKeyboardKeyBackgroundColor;
      keys[i].style.color = this.kioskKeyboardKeyTextColor;
    }
    for (let i = 0; i < test.length; i++) {
      test[i].style.backgroundColor = this.kioskKeyboardBackgroundColor;
      test[i].style.color = this.kioskKeyboardTextColor;
      test[i].style.borderColor = this.kioskKeyboardBackgroundColor;
    }
    this.$store.commit("updateMinSelectedAddition", 0);
    this.modifiers.map((x) => {
      this.$store.commit(
        "updateMinSelectedAddition",
        this.minSelectedAddition + x.minSelectedAmount
      );
    });
    if (window.innerWidth > 769) {
      this.mediumWidth = true;
    } else {
      this.mediumWidth = false;
    }
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.vm--modal {
  height: 90vh !important;
}
.tag {
  position: absolute;
  top: 8px;
  right: 8px;
}
.ItemDetail__banner {
  height: 20rem;
}
.OrderButton__backdrop {
  background: linear-gradient(0deg, white, transparent);
}

.ani-min-height {
  min-height: 100vh;
}
.custom-placeholder::placeholder{
  color: var(--search-placeholder-color);
}
@media (min-width: 768px) {
  .ani-min-height {
    min-height: 65vh;
  }
}
</style>
